import React, { memo, Suspense, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import WhiteBox from 'components/WhiteBox';
import ShopItemTeaser, { ShopItemTeaserSkeleton } from 'components/ShopItemTeaser';
import Model from '../../../../model';
import MobileSlider from 'components/Slider/MobileSlider';
import { times } from 'utils/render';
import './index.sass';

const { block, el } = bem('front-shop');

const Shop = () => {
    const { isMobile } = useMobile();
    const { activeItemsData } = Model.shop;

    const Fallback = isMobile ?
        <MobileSlider items={ times(() => <ShopItemTeaserSkeleton/>, 2) }/> :
        <div className={ el('teasers') }>{ times((key) => <ShopItemTeaserSkeleton key={ key }/>, 4) }</div>

    return (
        <div className={ block() }>
            <WhiteBox>
                <div className={ el('top-block') }>
                    <div className={ el('title') }>
                        <Text serif>Наш магазин</Text>
                    </div>
                    <div className={ el('description') }>
                        <Text>
                            Лучший подарок для каждого — найти свой Ответ. В витрине нашего магазина — все, что может в
                            этом помочь: сертификаты на сессии с психологами, образовательные курсы и красивые вещи со
                            смыслом, которые приятно подарить близким.
                        </Text>
                    </div>
                </div>
                <div className={ el('shop-items') }>
                    <Suspense fallback={ Fallback }>
                        <ShopItemsBlock resource={ activeItemsData }/>
                    </Suspense>
                </div>
                <div className={ el('button') }>
                    <IconButton name={ 'arrow-right' } to={ '/goods' } mod={ 'gold' }><Text>В
                        магазин</Text></IconButton>
                </div>
            </WhiteBox>
        </div>
    );
};

const ShopItemsBlock = memo(({ resource }) => {
    const items = resource.read();
    const { isMobile } = useMobile();
    const popularShopItems = useMemo(() => items.slice(0, 4), []);
    const teasers = useMemo(() => popularShopItems.map((item, index) => <ShopItemTeaser key={ index }
                                                                                        item={ item }/>), []);
    return isMobile ? <MobileSlider items={ teasers }/> : <div className={ el('teasers') }>{ teasers }</div>;
})

export default observer(Shop);
